export type Result<T, E = Error> =
    | { isSuccess: true; value: T; error?: never }
    | { isSuccess: false; value?: never; error: E };

export async function tryCatch<T, E = Error>(
  promise: Promise<T>,
): Promise<Result<T, E>> {
  try {
    const value = await promise;
    return {
      isSuccess: true, value: value as T,
    };
  } catch (error) {
    return {
      isSuccess: false, error: error as E,
    };
  }
}
